<style></style>

<template>
  <div id="como-participar" class="lista-dicas">
    <div class="row m-0">
      <div class="col-12">
        <h3>Conteúdo de Vídeo</h3>
      </div>
      <div class="col-12">
        <div class="form-group">
          <label for="paraVoce"
            >Vídeo para você (<b class="fs-14"
              >Insira o vídeo de incorporação nesse campo!</b
            >)</label
          >
          <textarea
            v-model="conteudo.paraVoce.value"
            id="paraVoce"
            class="form-control"
          ></textarea>
        </div>

        <div class="form-group">
          <label for="paraSuaEmpresa"
            >Vídeo para sua empresa (<b class="fs-14"
              >Insira o vídeo de incorporação nesse campo!</b
            >)</label
          >
          <textarea
            v-model="conteudo.paraSuaEmpresa.value"
            id="paraSuaEmpresa"
            class="form-control"
          ></textarea>
        </div>

        <div class="form-group">
          <label for="comoFazerCotacao"
            >Vídeo como fazer sua cotação (<b class="fs-14"
              >Insira o vídeo de incorporação nesse campo!</b
            >)</label
          >
          <textarea
            v-model="conteudo.paraComoFazerCotacao.value"
            id="comoFazerCotacao"
            class="form-control"
          ></textarea>
        </div>
      </div>
      <div class="col-12">
        <div class="btn btn-success c-pointer" @click="salvar">Salvar</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'inicio-page',
  data: () => ({
    conteudo: {
      paraVoce: {
        value: null,
      },
      paraSuaEmpresa: {
        value: null,
      },
      paraComoFazerCotacao: {
        value: null,
      },
    },
  }),
  computed: {
    ...mapGetters([
      'getTipoNotification',
      'getNotification',
      'getLoaderAction',
    ]),
    ...mapState({
      homeConteudo: (state) => state.homeConteudo,
    }),
  },
  created() {
    this.$store.dispatch('loadPaginaInicioConteudo').then((data) => {
      this.$store.dispatch('startLoader');
      setTimeout(() => {
        if (!this.checkIsEmpty(this.homeConteudo)) {
          this.conteudo.paraVoce.value = this.homeConteudo[0].video_para_voce;
          this.conteudo.paraSuaEmpresa.value =
            this.homeConteudo[0].video_para_sua_empresa;
          this.conteudo.paraComoFazerCotacao.value =
            this.homeConteudo[0].video_para_como_fazer_cotacao;
        }
        this.$store.dispatch('endLoader');
      }, 1500);
    });
  },
  methods: {
    aviso(texto, tipo) {
      this.$bvToast.toast(texto, {
        title: 'Aviso',
        variant: tipo,
        autoHideDelay: 5000,
        appendToast: true,
      });
    },
    checkIsEmpty(value) {
      if (
        value === '' ||
        value === null ||
        value === 'null' ||
        value === 'undefined'
      ) {
        return true;
      }
      return false;
    },
    salvar() {
      const data = {
        video_para_voce: this.conteudo.paraVoce.value,
        video_para_sua_empresa: this.conteudo.paraSuaEmpresa.value,
        video_para_como_fazer_cotacao: this.conteudo.paraComoFazerCotacao.value,
      };

      this.$store.dispatch('startLoader');
      this.$store
        .dispatch('updateInicioPaginaConteudo', data)
        .then((data) => {
          setTimeout(() => {
            this.$store.dispatch('loadPaginaInicioConteudo').then((data) => {
              setTimeout(() => {
                if (!this.checkIsEmpty(this.homeConteudo)) {
                  this.conteudo.paraVoce.value =
                    this.homeConteudo[0].video_para_voce;
                  this.conteudo.paraSuaEmpresa.value =
                    this.homeConteudo[0].video_para_sua_empresa;
                  this.conteudo.paraComoFazerCotacao.value =
                    this.homeConteudo[0].video_para_como_fazer_cotacao;
                }
                this.$store.dispatch('endLoader');
              }, 1500);
            });
          }, 1000);
        })
        .catch((data) => {
          this.$store.dispatch('endLoader');
        });
    },
  },
};
</script>
